module.exports = __webpack_public_path__ + "static/media/8.30ee7851.jpg";